export const validateHour = (hour: string) => {
  const hourAsNumber = Number(hour);
  if (isNaN(hourAsNumber)) return false;
  return hourAsNumber >= 1 && hourAsNumber <= 12;
};

export const validateMinute = (minute: string) => {
  const minuteAsNumber = Number(minute);
  if (isNaN(minuteAsNumber)) return false;
  return minuteAsNumber >= 0 && minuteAsNumber <= 59;
};
